/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jumpy_North_Salmon_LoveInputs */

const fr_jumpy_north_salmon_love = /** @type {(inputs: Jumpy_North_Salmon_LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux de rebond`)
};

/**

* @param {Jumpy_North_Salmon_LoveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const jumpy_north_salmon_love = /** @type {((inputs?: Jumpy_North_Salmon_LoveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jumpy_North_Salmon_LoveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_jumpy_north_salmon_love(inputs)
});